var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Menu Open"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.75 17.75V15.875H8.1125V17.75H20.75ZM4.55 16.775L9.4 12L4.55 7.225L3.25 8.525L6.775 12L3.25 15.4625L4.55 16.775ZM20.75 12.925V11.05H11.05V12.925H20.75ZM20.75 8.125V6.25H8.1125V8.125H20.75Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuOpen);
export default __webpack_public_path__ + "static/media/icon-menu-open.ee69d7960be7c4e44ee533f5a3ccb8a4.svg";
export { ForwardRef as ReactComponent };